import React from 'react';

export default class CourseContentManagement extends React.Component
{
    render()
    {
        return (
            <div className="lmsdisplayarea">
                <h3>Manage Course Content</h3>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/course/management/coursecontentmanagement.js